var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('st-music-player',{style:(_vm.elemStyles),attrs:{"mid":_vm.mid},model:{value:(_vm.playerState),callback:function ($$v) {_vm.playerState=$$v},expression:"playerState"}})}
var staticRenderFns = []

export { render, staticRenderFns }